import ServiceLayout from "./ServiceLayout";
import { Typography, Box } from "@mui/material";
import { Helmet } from "react-helmet-async";

const DripIrrigation = () => {
  return (
    <>
      <Helmet>
        <title>Drip Irrigation | KRM Landscape</title>
        <meta
          name="description"
          content="Efficient drip irrigation systems by KRM Landscape to optimize water usage and support healthy plant growth."
        />
        <meta
          name="keywords"
          content="Drip Irrigation, Water Conservation, Landscape Irrigation, KRM Landscape"
        />
      </Helmet>

      <ServiceLayout title="Drip Irrigation">

        {/* Hero Image */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Box
            component="img"
            src="/images/dripirrigation.webp"
            alt="Drip Irrigation System by KRM Landscape"
            sx={{
              width: { xs: "100%", md: "80%" },
              maxHeight: "400px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </Box>

        <Typography paragraph>
          Our Drip Irrigation service provides an efficient and sustainable
          watering solution designed to conserve water while promoting healthy
          plant growth. This system delivers water directly to plant roots,
          minimizing wastage and evaporation.
        </Typography>

        <Typography paragraph>
          We design and install customized drip irrigation systems for gardens,
          lawns, kitchen gardens, vertical gardens, and agricultural landscapes.
          Each setup is planned based on soil type, plant variety, and water
          requirements.
        </Typography>

        <Typography paragraph>
          Our team ensures precise layout, quality piping, proper pressure control,
          and easy-to-use automation options. The system not only saves water but
          also reduces manual effort and maintenance costs.
        </Typography>

        <Typography paragraph>
          With KRM Landscape’s drip irrigation solutions, your plants receive
          consistent hydration, healthier growth, and long-term sustainability,
          making smart irrigation an investment in both nature and efficiency.
        </Typography>

      </ServiceLayout>
    </>
  );
};

export default DripIrrigation;
